import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.DownloadFile,
  title: 'Download File',
  category: ComponentCategory.General,
};
